import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Discussion } from '@core/models/discussion.model';
import { environment } from '@environment/environment';

@Injectable()
export class ReportingService {
  constructor(private httpClient: HttpClient) {}

  reportError(errorMessage: string, errorMetadata: any) {
    const route = `${environment.examInfoBackend}/report_error`;
    return this.httpClient.post<Discussion>(route, {
      error_message: errorMessage,
      error_metadata: errorMetadata,
    });
  }
}
